
let nav = null;
let apikey = null;
let student = null;

window.login = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'login',
    data: JSON.stringify({
      email: $('#email').val(),
      pass: $('#pass').val(),
    }),
    success: function(response) {
      $('ons-progress-bar').hide();
      if (response.apikey) {
        localStorage.setItem('apikey',response.apikey);
        parse(response);
      }
      else {
        ons.notification.toast('Κατι πήγε λάθος! Δοκιμάστε ξανά.', {
          timeout: 2000
        });
        setTimeout(function() { $('ons-button.forget_pass').fadeIn(); }, 3000);
      }
    }
  });
}

window.forget_pass = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'forget_pass',
    data: JSON.stringify({
      email: $('#email_forget').val(),
      url: location.href
    }),
    success: function(response) {
      $('ons-progress-bar').hide();
      if (response.success) {
        window.show_login();
      }
      else {
        ons.notification.toast('Δεν υπάρχει χρήστης με αυτό το email.', {
          timeout: 2000
        });
        $('#email_forget').val('');
      }
    }
  });
}

window.change_pass = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'change_pass',
    data: JSON.stringify({
      apikey: localStorage.getItem('apikey'),
      pass: $('#pass').val(),
      reset: $('#reset').val(),
      new_pass: $('#new_pass').val(),
      repeat_pass: $('#repeat_pass').val(),
    }),
    success: function(response) {
      $('ons-progress-bar').hide();
      if (response.success) {
        window.logout();
      }
      else {
        ons.notification.toast('Κατι πήγε λάθος! Δοκιμάστε ξανά.', {
          timeout: 2000
        });
        $('#pass,#new_pass,#repeat_pass').val('');
      }
    }
  });
}

window.logout = () => {
  if (student!=null) {
    student = null;
    localStorage.removeItem('apikey');
    nav.resetToPage('views/login.html?'+hash);
  }
  else {
    location.href='/';
  }
}

window.parse = (response) => {
  if (!response.success) {
    logout();
    return;
  }
  console.log(response);
  student = response;

  //enum('pending','filled-form','uploaded-photos','started','on-target','success','failed')
  switch (response.state) {
    case 'pending':
      nav.resetToPage('views/google_form.html?'+hash);
      return;
    case 'filled-form':
      nav.resetToPage('views/photos.html?'+hash);
      return;
    case 'uploaded-photos':
      nav.resetToPage(student.week>0 ? 'views/target.html?'+hash : 'views/start.html?'+hash);
      return;
    case 'started':
      if (student.week>1) {
        nav.resetToPage('views/target.html?'+hash);
        return;
      }
  }
  
  nav.resetToPage('views/home.html?'+hash);
}

window.photos = (fld) => {
  $.ajax( {
    type: 'POST',
    dataType: 'html',
    url: apiurl+'list_photos',
    data: JSON.stringify({
      apikey: localStorage.getItem('apikey'),
      photo: fld,
    }),
    success: function(html) {
      if (html.length > 10) {
        $('#fld_'+fld).val('on');
        $('#camera_'+fld).hide();
      }
      else {
        $('#fld_'+fld).val('');
        $('#camera_'+fld).show();
      }
      $('#photos_'+fld).html(html);
    }
  });
}

window.required = () => {
  let ok = true;
  $('input[required],select[required]').each(function() {
    if ($(this).attr('type')!='hidden' && $(this).is(':hidden')) {
        return true;
    }
    if ($(this).attr('type')=='checkbox' && !this.checked) {
        ok=false;
        return false;
    }
    if ($(this).parent().hasClass('error')) {
        ok=false;
        return false;
    }
    if (!$(this).val() || $(this).val()=='0') {
        ok=false;
        return false;
     }
  });
  return ok;
}

window.done_photos = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'done_photos',
    data: JSON.stringify({
      apikey: localStorage.getItem('apikey'),
      weight: $('input[name="weight"]').val()
    }),
    success: function(response) {
      $('ons-progress-bar').hide();
      parse(response);
    }
  });
}

window.save_target = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  let data = {
    apikey: localStorage.getItem('apikey'),
    type: $('#fld_type').val(),
    weight: $('#fld_weight').val(),
    ideal_weight: $('#fld_ideal_weight').val(),
    grams_week: $('#fld_grams_week').val(),
    kg_semester: $('#fld_kg_semester').val(),
  };
  if ($('#fld_week').val()) {
    data.week = $('#fld_week').val();
    data.plato_level = $('#fld_plato_level').val();
    data.plato_stuck = $('#fld_plato_stuck').val();
  }
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'save_target',
    data: JSON.stringify(data),
    success: function(response) {
      $('ons-progress-bar').hide();
      parse(response);
    }
  });
}

window.start = () => {
  if (!required()) {
    return false;
  }
  $('ons-progress-bar').show();
  const data = {
    apikey: localStorage.getItem('apikey')
  };
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'letstart',
    data: JSON.stringify(data),
    success: function(response) {
      $('ons-progress-bar').hide();
      parse(response);
    }
  });
}

window.save_checklist = () => {

  $('ons-progress-bar').show();
  let data = {
    apikey: localStorage.getItem('apikey')
  };
  $('ons-input.numeric').each(function() {
    const day = $(this).attr('name').split('_')[0];
    data[$(this).attr('name')] = $(this).val();
    data[day+'_diet'] = $('#fld_'+day+'_diet').is(':checked') ? '1' : '0';
    data[day+'_gym'] = $('#fld_'+day+'_gym').is(':checked') ? '1' : '0';
    data[day+'_notes'] = $('#fld_'+day+'_notes').val();
  });
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'save_checklist',
    data: JSON.stringify(data),
    success: function(response) {
      $('ons-progress-bar').hide();
      parse(response);
    }
  });

}

window.upload = (inp,fld) => {

    const output = inp.files[0];
    const formData = new FormData();
    formData.append('apikey', localStorage.getItem('apikey'));
    formData.append('photo', fld);
    formData.append('file', output, output.name);
        
    $('#loader_'+fld).fadeIn();
    $.ajax( {
      type: 'POST',
      dataType: 'json',
      url: apiurl+'upload_photo',
      data: formData,
      processData: false,
      contentType: false,
      timeout: 300000, 
      success: function(response) {
        $('#loader_'+fld).fadeOut();
        if (response.success) {
          window.photos(fld);
          $('#camera_'+fld).hide();
        }
      },
      error: function(){
        $('#loader_'+fld).fadeOut();
        window.photos(fld);
      }
    });
}

window.deleteFile = (ico,file) => {
  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'delete_file',
    data: JSON.stringify({
      apikey: localStorage.getItem('apikey'),
      file: file
    }),
    success: function(response) {
      
      const item = ico.closest('div');
      const itemsId = item.parent().attr('id');
      const fld = itemsId.replace('photos_','');
      console.log(fld);
      item.fadeOut(function() {
        item.remove();
        if ($('#'+itemsId).html().length > 10) {
          $('#fld_'+fld).val('on');
          $('#camera_'+fld).hide();
        }
        else {
          $('#fld_'+fld).val('');
          $('#camera_'+fld).show();
        }
      })
    }
  });
}

window.switch_fld = (fld) => {
  if ($('#switch_fld_'+fld).is(':checked')) {
    $('#switch_lbl_'+fld).hide();
    $('#fld_'+fld).show();
    setTimeout(function() { $('#fld_'+fld).find('input').focus(); },500);
  }
  else {
    $('#switch_lbl_'+fld).show();
    $('#fld_'+fld).hide();
  }
}

window.select_target = (type) => {
  switch (type) {
    case 'shrink': 
      $('.item_ideal_weight,.item_kg_goal,.item_grams_week,.item_kg_semester,.item_plato_level,.item_plato_stuck').show();
      break;
    case 'growth': 
    case 'keep': 
      $('.item_ideal_weight,.item_kg_goal,.item_grams_week,.item_kg_semester,.item_plato_level,.item_plato_stuck').hide();
      break;
  }
}

window.calculate_target = (source) => {
  const weight = parseFloat($('#fld_weight').val());
  const ideal_weight = parseFloat($('#fld_ideal_weight').val());
  $('#fld_kg_goal,#fld_kg_semester').val('');
  $('#fld_ideal_weight').removeClass('error');
  let grams_week = parseInt($('#fld_grams_week').val());
  if (!grams_week && weight>0 && source!="grams_week") {
    let percent = 0.5;
    if (weight >= 120) {
      percent = 1.5;
    }
    else if (weight >= 100) {
      percent = 1;
    }
    else if (weight >= 80) {
      percent = 0.8;
    }
    percent/=100;
    grams_week = parseInt(weight*percent*1000);
    $('#fld_grams_week').val(grams_week);
  }
  if (!weight || !ideal_weight) {
    return;
  }
  if (ideal_weight >= weight) {
    $('#fld_ideal_weight').addClass('error');
    return;
  }
  const kg_goal = weight-ideal_weight;
  $('#fld_kg_goal').val(kg_goal.toFixed(1));
  const kg_semester = (grams_week * 12) / 1000;
  $('#fld_kg_semester').val(kg_semester.toFixed(1));
}

window.home = () => {
  nav.resetToPage('views/home.html?'+hash);
}

window.checklist = () => {
  nav.pushPage('views/checklist.html?'+hash); 
}

window.progress = () => {
  nav.pushPage('views/progress.html?'+hash); 
}

window.transformation = () => {
  nav.pushPage('views/transformation.html?'+hash); 
}

window.target = () => {
  nav.pushPage('views/target.html?'+hash); 
}

window.show_login = () => {
  nav.resetToPage('views/login.html?'+hash);
}

window.show_forget_pass = () => {
  nav.pushPage('views/forget_pass.html?'+hash);
}

window.show_change_pass = () => {
  nav.pushPage('views/change_pass.html?'+hash);
}

window.open_photos = () => {
  nav.pushPage('views/photos.html?'+hash);
}

window.help = (section) => {
  nav.pushPage('views/help_'+section+'.html?'+hash);
}

ons.ready(function() {

  nav = $('#navigator')[0];

  if (document.location.search.indexOf('reset=')>-1) {
    localStorage.removeItem('apikey');
    nav.resetToPage('views/change_pass.html?'+hash,{
      data: {
        reset: document.location.search.split('reset=')[1]
      }
    });
    return;
  }

  apikey = localStorage.getItem('apikey');
  if (!apikey) {
    nav.resetToPage(apikey ? 'views/home.html?'+hash : 'views/login.html?'+hash);
    return;
  }

  $.ajax( {
    type: 'POST',
    dataType: 'json',
    url: apiurl+'get_student',
    data: JSON.stringify({
      apikey: localStorage.getItem('apikey'),
    }),
    success: function(response) {
      parse(response);
    }
  });  
  
});

showOptions = (options) => {
  html='';
  $.each(options,function(i,v){
    if (v[0]=='@') {
      v=v.substr(1);
      html+='<option selected="selected" value="'+v+'">'+v+'</option>';
    }
    else {
      html+='<option value="'+v+'">'+v+'</option>';
    }
  });
  return html;
}

showOptionsWithKey = (options) => {
  html='';
  $.each(options,function(i,v){
      html+='<option value="'+i+'">'+v+'</option>';
  });
  return html;
}

showItemField = (fld, data, asArray) => {

    const name = fld + (asArray ? '[]' : '');
    switch(data.type) {

      case 'switch':
          return '<label class="center" for="fld_'+fld+'">'+data.title+'</label>\
            <div class="right"><ons-switch onchange="'+(data.onchange?data.onchange:'')+'" name="'+name+'" \
                '+(data.value==true?'checked':'')+' '+(data.required?'required':'')+' input-id="fld_'+fld+'"></ons-switch></div>';

      case 'select':
        return '<ons-select '+(data.required?'required':'')+' onchange="'+(data.onchange?data.onchange:'')+'" name="'+name+'" id="fld_'+fld+'">'
            + (data.withKey ? showOptionsWithKey(data.options) : showOptions(data.options)) + '</ons-select>';
          
     case 'photo':
          window.photos(fld);
          return '<div id="photos_'+fld+'" class="photos"></div>\
              <input '+(data.required?'required':'')+' type="hidden" name="'+fld+'" id="fld_'+fld+'" value=""></input>\
              <input name="file" type="file" accept="image/jpeg" style="display:none" id="upload_'+fld+'" onchange="window.upload(this,\''+fld+'\')"></input>\
              <label style="width:100%" for="upload_'+fld+'"><ons-icon id="camera_'+fld+'" icon="fa-camera"></ons-icon>\
              <ons-progress-circular id="loader_'+fld+'" style="width:18px;height:14px;margin-left:4px;display:none" indeterminate></ons-progress-circular></label>';
            
      default:
          const placeholder = data.placeholder?data.placeholder:data.title;
          let html = '<ons-input '+(data.required?'required':'')+' name="'+name+'" id="fld_'+fld+'" \
                style="width:98%'+(data.switch && data.value=='' ? ';display:none' : '')+'" type="'+data.type+'" \
                onblur="'+(data.onchange?data.onchange:'')+'" '+(data.readonly?'readonly':'')+' \
                class="'+data.type+'" placeholder="'+placeholder+'" value="'+data.value+'"></ons-input>';
          if (data.switch) {
            const switch_title = data.switch_title?data.switch_title:placeholder;
            html = '<label class="center" for="switch_fld_'+fld+'">'+html+'\
                <span '+(data.value?'style="display:none"':'')+' id="switch_lbl_'+fld+'">'+switch_title+'</span></label>';
          }
          return html;
    }
}

showItem = (fld, data) => {

    let html='';

    if (data.title && data.type!='switch') {
        html+='<ons-list-header id="head_'+fld+'" class="item_'+fld+'">'+data.title+'</ons-list-header>';
    }
    
    switch(data.type) {
      case 'radio':
          $.each(data.options,function(i,v){
            html+='<ons-list-item  class="item_'+fld+'" tappable>\
                <label class="left"><ons-radio name="'+fld+'" value="'+v+'" input-id="radio-'+i+'"></ons-radio></label>\
                <label for="radio-'+i+'" class="center">'+v+'</label>\
                </ons-list-item>';
          });
          break;

      case 'group-select':
          html+='<div class="items">\
            <ons-list-item class="item_'+fld+'">\
            <div class="center">\
            <ons-select name="'+fld+'[0][]" id="fld_'+fld+'">'
            +showOptions(data.options[0])+
            '</ons-select>\
            </div>';

          if (data.one_line) {
            html+='<div class="right">';
          }
          else {
            html+='</ons-list-item>\
              <ons-list-item class="item_'+fld+'">\
              <div class="center">';
          }
            
          html+='<ons-select name="'+fld+'[1][]" id="fld_'+fld+'">'
          +showOptions(data.options[1])+
          '</ons-select>\
            </div>\
            </ons-list-item>\
            </div>';
          break;

      case 'textarea':
          html+='<ons-list-item class="item_'+fld+'">\
              <textarea name="'+fld+'" id="fld_'+fld+'" style="width:98%" class="textaream textarea--transparent" rows="5" \
              placeholder="'+(data.placeholder?data.placeholder:'')+'">'+data.value+'</textarea>\
              </ons-list-item>';
          break;

      default:
          html+='<ons-list-item class="item_'+fld+'">';
          html+=showItemField(fld, data, false);
          if (data.switch) {
            html+='<div class="right"><ons-switch onchange="window.switch_fld(\''+fld+'\')" \
                '+(data.value?'checked':'')+' input-id="switch_fld_'+fld+'"></ons-switch></div>';
          }
          html+='</ons-list-item>';
    }
    return html;
}

showProfile = () => {

  let html = '<img style="border-radius: 10%;box-shadow: 5px 5px 10px #888;" src="'+student.thumb+'">\
        <h1>'+student.name+'</h1><div class="title">';
    if (student.weight) {
        html+= '<strong>'+student.weight+' κιλά</strong><br><br>';
    }
    html+= (student.week>0) ? student.week+'η εβδομάδα<br>' : 'Εβδομάδα Mindset<br>';
    if (student.weight_target) {
        html+= 'Στόχος '+student.weight_target+'<br>';
        html+= 'Επίπεδο '+student.plato_level+'<br>';
        if (student.plato_stuck>0) {
          html+= student.plato_stuck+'η εβδομάδα αναμονής<br>';
        }
    }

    if (student.badges) {
      html+='<ul class="badges">';
      const cl = [];
      cl['']
      cl['upload_photos'] = 'fa-camera';
      cl['first_checklist'] = 'fa-calendar';
      cl['done_checklist'] = 'fa-calendar-check';
      cl['set_target'] = 'fa-bullseye';
      cl['lost_1kg'] = 'fa-1kg';
      cl['lost_5kg'] = 'fa-5kg';
      cl['lost_10kg'] = 'fa-10kg';
      cl['lost_20kg'] = 'fa-20kg';
      cl['done_target'] = 'fa-trophy';
      $.each(student.badges,function(name,value) {
          value = parseInt(value);
          if (name=='lost_10kg' && !value) {
            return;
          }
          if (name=='lost_20kg' && !value) {
            return;
          }
          html+='<li class="fa '+cl[name]+' '+(value?'ok':'')+'"></li>';
      });
      html+='</ul>';
    }

    html+='</div>';
    $('ons-card').append(html);
}

document.addEventListener('postpush', function(event) {
  
  let html = '';
  const page = event.enterPage;
  
  if (page.id === 'photos') {

    html = 
    showItem('front', {type: 'photo', required: true, title:'Μπροστα'})+
    showItem('side', {type: 'photo', required: true, title:'Πλαγια'})+
    showItem('hands-up', {type: 'photo', required: true , title:'Χερια ψηλα'})+
    showItem('back', {type: 'photo', required: true, title:'Πισω'});

    if (!student.weight) {
      html+=showItem('weight', {type: 'numeric', required: true, title:'Βαρος', value: ''});
    }

    $('ons-list').append('<div id="wrap_photos">'+html+'</div>');
    if (student.state!='filled-form') {
        $('ons-button.next').text('Save');
    }
  } // photos

  if (page.id === 'home') {
    
    showProfile();
    if (student.week>3 || (student.week>0 && (new Date()).getDay()==0)) {
        $('ons-button.checklist').prop('disabled',false);
    }
    if (student.week > student.week_photo) {
        $('ons-button.photos').prop('disabled',false);
    }
    if (student.week>4) {
        $('ons-button.progress').prop('disabled',false);
    }
    if (student.week_photo > 0) {
      $('ons-button.transformation').prop('disabled',false);
    }

    if (student.last_message) {
        ons.notification.toast(student.last_message, {
          buttonLabel: 'close'
        }).then(function(name) {
          
          $.ajax( {
            type: 'POST',
            dataType: 'json',
            url: apiurl+'read_last_message',
            data: JSON.stringify({
              apikey: localStorage.getItem('apikey'),
            })
          }); 

        });
    }
    else if (student.photo_notes) {
      const hash_notes = md5(student.photo_notes);
      if (hash_notes != localStorage.getItem('hash_notes')) {
          ons.notification.toast(student.photo_notes, {
            buttonLabel: 'close'
          }).then(function(name) {
              localStorage.setItem('hash_notes', hash_notes);
          });
      }
    }

  } // home

  if (page.id === 'checklist') {

    $('ons-progress-bar').show();
    $.ajax( {
      type: 'POST',
      dataType: 'json',
      url: apiurl+'checklist',
      data: JSON.stringify({
        apikey: localStorage.getItem('apikey'),
      }),
      success: function(response) {
        $('ons-progress-bar').hide();
        if (response.success) {
          $.each(response.days,function(day_fld,day_data){
            html+= 
            showItem(day_fld+'_weight', {
                type: 'numeric', required: true, switch: true, title:day_data.name, 
                switch_title:'Ζυγίστηκες ;', placeholder: 'Γράψε το βάρος σου', value: day_data.weight
            })+
            showItem(day_fld+'_diet', {type: 'switch', title:'Ήσουν πιστ'+(student.sex=='male'?'ός':'ή')+' στη διατροφή σου ;', value:day_data.diet})+
            showItem(day_fld+'_gym', {type: 'switch', title:'Έκανες προπόνηση (ή δεν είχες) ;', value:day_data.gym})+
            showItem(day_fld+'_notes', {type: 'textarea', placeholder:'Σημειώσεις', value:day_data.notes});
          });

          $('ons-list').append('<div id="wrap_checklist">'+html+'</div>');
          $('ons-button.save').show();

          if (response.first && !localStorage.getItem('show_checklist_help')) {
              localStorage.setItem('show_checklist_help', true);
              help('checklist');
          }
        }
      }
    });

  } // checklist

  if (page.id === 'transformation') {

    $('ons-progress-bar').show();
    $.ajax( {
      type: 'POST',
      dataType: 'json',
      url: apiurl+'transformation',
      data: JSON.stringify({
        apikey: localStorage.getItem('apikey'),
      }),
      success: function(response) {
        $('ons-progress-bar').hide();
        if (response.success) {
            let weeks = '<div style="width:100%;text-align:center">'+
                          response.weeks.last+'η εβδομάδα'+ '</div>';
            let front = '<img style="width:100%" src="'+response.photos.last.front+'"/>';
            let side = '<img style="width:100%" src="'+response.photos.last.side+'"/>';
            let handsup = '<img style="width:100%" src="'+response.photos.last.handsup+'"/>';
            let back = '<img style="width:100%" src="'+response.photos.last.back+'"/>';
            if (response.photos.first) {
              weeks = '<div style="width:50%;float:left;text-align:center">'+
                          response.weeks.first+'η εβδομάδα'+
                        '</div><div style="width:50%;float:left;text-align:center">'+ 
                          response.weeks.last+'η εβδομάδα'+ '</div>';
              front = '<div style="width:50%;float:left;">'+
                          '<img style="width:100%" src="'+response.photos.first.front+'"/>'+
                        '</div><div style="width:50%;float:left;">'+ front + '</div>';
              side = '<div style="width:50%;float:left;">'+
                          '<img style="width:100%" src="'+response.photos.first.side+'"/>'+
                        '</div><div style="width:50%;float:left;">'+ side + '</div>';
              handsup = '<div style="width:50%;float:left;">'+
                          '<img style="width:100%" src="'+response.photos.first.handsup+'"/>'+
                        '</div><div style="width:50%;float:left;">'+ handsup + '</div>';
              back = '<div style="width:50%;float:left;">'+
                          '<img style="width:100%" src="'+response.photos.first.back+'"/>'+
                        '</div><div style="width:50%;float:left;">'+ back + '</div>';
            }
            html+='<ons-list-item>'+weeks+'</ons-list-item>';
            html+='<ons-list-item>'+front+'</ons-list-item>';
            html+='<ons-list-item>'+side+'</ons-list-item>';
            html+='<ons-list-item>'+handsup+'</ons-list-item>';
            html+='<ons-list-item>'+back+'</ons-list-item>';
        }
        $('ons-list').append(html);
      }
    });

  } // transformation

  if (page.id === 'progress') {

    $('ons-progress-bar').show();
    $.ajax( {
      type: 'POST',
      dataType: 'json',
      url: apiurl+'progress',
      data: JSON.stringify({
        apikey: localStorage.getItem('apikey'),
      }),
      success: function(response) {
        $('ons-progress-bar').hide();
        if (response.success) {
          $.each(response.progress,function(tmp,data){
              html+='<ons-list-header>'+(data.week>0 ? data.week+'η εβδομαδα<br>' : 'Εβδομαδα Mindset')+'</ons-list-header>';
              html+='<ons-list-item>';
              if (data.weight!=0) {
                let left = '&nbsp;',diff = '';
                if (data.diff_grams!=0) {
                  left = '<ons-icon icon="'+(data.diff_grams<0 ? 'md-trending-down' : 'md-trending-up') + '"></ons-icon>';
                  if (data.diff_grams<0) {
                    diff = '<span style="color:green">- '+Math.abs(data.diff_grams)+' γραμ</span>';
                  }
                  else {
                    diff = '<span style="color:red">+ '+data.diff_grams+' γραμ</span>';
                  }
                }
                html+='<div class="left">'+left+'</div>';
                html+='<div class="center">'+data.weight+' κιλά</div>';
                if (diff) {
                  html+='<div class="right">'+diff+'</div>';
                }
              }
              else {
                html+='&nbsp;';
              }
              html+='</ons-list-item>';
          });

          $('ons-list').append('<div id="wrap_checklist">'+html+'</div>');

        }
      }
    });

  } // progress

  if (page.id === 'start') {
    
    showProfile();
    html+=
    showItem('check1', {type: 'switch', required: true, title:'1 τετράδιο + στιλό',})+
    showItem('check1', {type: 'switch', required: true, title:'Ζυγαριά μπάνιου'})+
    showItem('check1', {type: 'switch', required: true, title:'Ζυγαριά κουζίνας'});

    $('ons-list').append('<div id="wrap_start">'+html+'</div>');
  
  } // start

  if (page.id === 'target') {
    html=
    showItem('type', {type: 'select', title:'Προγραμμα', onchange: 'window.select_target(this.value)', required: true, value: 'shrink', withKey:true, options: {
      'shrink': 'Χάσιμο λίπους',
      'growth': 'Αύξηση όγκου',
      'keep': 'Συντήρηση'
    }})+
    showItem('weight', {type: 'numeric', onchange: 'window.calculate_target(\'weight\')', required: true, title:'Βαρος', placeholder: ' ', value: student.weight})+
    showItem('ideal_weight', {type: 'numeric', onchange: 'window.calculate_target(\'ideal_weight\')', required: true, title:'Ιδανικο βαρος', placeholder:  ' ', value: ''})+
    showItem('kg_goal', {type: 'numeric', readonly: true, title:'Συνολικα κιλα στοχου', placeholder: ' ', required: true, value: ''})+
    showItem('grams_week', {type: 'numeric', onchange: 'window.calculate_target(\'grams_week\')', title:'Γραμμαρια ανα εβδομαδα', placeholder: ' ', required: true, value: ''})+
    showItem('kg_semester', {type: 'numeric', readonly: true, title:'Κιλα ανα τριμηνο', placeholder: ' ', required: true, value: ''});

    if (student.state=='uploaded-photos' && student.week>3) {
      html+= 
      showItem('week', {type: 'numeric', required: true, title:'Τρεχουσα εβδομαδα', placeholder: ' ', value: student.week})+
      showItem('plato_level', {type: 'select', title:'Επιπεδο πλατοθραυστη', required: true, value: '1', options: [1,2,3]}) + 
      showItem('plato_stuck', {type: 'select', title:'Κολλησα στα κιλα ;', value: '0', withKey:true, options: {
        '0':'Όχι',
        '1':'1η εβδομάδα',
        '2':'2η εβδομάδα'
      }});
    }

    $('ons-list').append('<div id="wrap_target">'+html+'</div>');
    if (student.weight) {
      $('#fld_weight').blur();
      setTimeout(function() { $('#fld_ideal_weight input').focus(); },500);
    }
    else {
      setTimeout(function() { $('#fld_weight input').focus(); },500);
    }
    $('ons-button.save').show();

  } // target

  if (page.id=='change_pass') {
    if (page.data.reset) {
      $('input#reset').val(page.data.reset);
      $('#pass').parent().hide();
    }
  } // change_pass

});

document.addEventListener('postpop', function(event) {

});